<template>
    <div v-if="type !== 'marketing'" class="pdpa-detail-wrapper custom-scrollbar" :class="type"
        v-html="content"
        @scroll="onScroll()"
        ref="pdpaContent">
    </div>
    <div v-else class="pdpa-mkt-detail-wrapper">
        <!-- <div class="mkt-content" v-html="content"></div> -->
        <div ref="pdpaContent"
            class="mkt-content custom-scrollbar"
            @scroll="onScroll()"
            v-html="content">
        </div>
        <div class="pdpa-market">
            <div class="allow-channel">{{lbl.pdpa.allow_channel}}</div>
            <div class="checkbox-group-wrapper">
                <CheckBox
                    class="checkbox-margin"
                    v-model="isAcceptEmail"
                    :setValue="isAcceptEmail"
                    :textLbl="lbl.pdpa.checkbox_email"
                    @input="updateChecked('email', $event)"
                ></CheckBox>
                <CheckBox
                    v-model="isAcceptSms"
                    :setValue="isAcceptSms"
                    :textLbl="lbl.pdpa.checkbox_sms"
                    @input="updateChecked('sms', $event)"
                ></CheckBox>
            </div>
        </div>
    </div>
</template>
<script>
// helper
import CacheHelper from '@/helper/CacheHelper';
// component
import CheckBox from './CheckBoxPDPA.vue';
// mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
// core
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';

export default {
    name: 'PdpaContent',
    mixins: [ErrorApiMixin, LocaleMixin, ModalMixin],
    props: {
        // version
        version: { type: Number },
        // props
        type: { type: String, default: 'terms' }, // terms, privacy
    },
    components: {
        CheckBox
    },
    data: function () {
        return {
            content: '',
            contentVersion: '',
            isAcceptEmail: false,
            isAcceptSms: false,
            sessionCache: new CacheHelper('session'),
        };
    },
    created: function () {
        if(this.type == 'marketing'){
            this.restoreCheckbox();
        }
        this.initPdpa();
    },
    mounted() {

    },
    methods: {
        restoreCheckbox: function(){
            let cacheData = this.sessionCache.getCache('pdpa');
            if(cacheData){
                this.isAcceptEmail = cacheData.mkt_channel.email;
                this.isAcceptSms = cacheData.mkt_channel.sms;
            }
        },
        initPdpa: async function () {
            await this.getVersion();
            if (!this.contentVersion) return;

            await this.getContent();
            if (!this.content) return;

            if(this.content){
                this.onScroll();
            }
        },
        getVersion: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAVersion()
                    .subscribe({
                        next: (res) => {
                            if(this.type == 'terms'){
                                this.contentVersion = res.terms.current_version;
                            }
                            if(this.type == 'privacy'){
                                this.contentVersion = res.privacy.current_version;
                            }
                            if(this.type == 'marketing'){
                                this.contentVersion = res.marketingOption.current_version;
                            }
                            this.$emit('update:version', {
                                termsVersion: res.terms.current_version,
                                privacyVersion: res.privacy.current_version,
                                marketingVertion: res.marketingOption.current_version,
                            });
                            resolve(true);
                        },
                        error: (err) => {
                            this.sendError(err);
                            resolve(null);
                        }
                    });
            });
        },
        getContent: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent(this.type, this.contentVersion, this.localeCode)
                    .subscribe({
                        next: (res) => {
                            this.content = res;
                            resolve(res);
                        },
                        error: (err) => {
                            this.sendError(err);
                            resolve(null);
                        }
                    });
            });
        },
        sendError: function (error) {
            this.$emit('onError', error);
        },
        onScroll () {
            const element = this.$refs.pdpaContent;
            this.clientHeight = element.clientHeight
            this.scrollHeight = element.scrollHeight
            this.scrollTop = element.scrollTop

            let bottomOfContent = false;
            if ((this.scrollTop + this.clientHeight)+5 >= this.scrollHeight) {
                bottomOfContent = true;
            }
            console.log(bottomOfContent)
            this.$emit('onScroll', bottomOfContent);
        },
        updateChecked: function(type, isChecked){
            let sendInfo = { type: type , isChecked: isChecked }
            this.$emit('updateMKTChannel', sendInfo);
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseUtility.scss";
</style>
